{
    "v": "5.7.4",
    "fr": 30,
    "ip": 0,
    "op": 30,
    "w": 96,
    "h": 60,
    "nm": "Dots Loading",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Dot 4",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        111.203,
                        50.69899999999999,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        93.75,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    12.8,
                                    12.8
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 9,
                                        "s": [
                                            -4,
                                            0
                                        ],
                                        "to": [
                                            0,
                                            -2.667
                                        ],
                                        "ti": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 15,
                                        "s": [
                                            -4,
                                            -16
                                        ],
                                        "to": [
                                            0,
                                            0
                                        ],
                                        "ti": [
                                            0,
                                            -2.667
                                        ]
                                    },
                                    {
                                        "t": 21.0,
                                        "s": [
                                            -4,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1568627450980392,
                                    0.396078431372549,
                                    0.5333333333333333,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    -25.204,
                                    -18.699
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Ellipse 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 330.000013441176,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Dot 3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        83.219,
                        50.69899999999999,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        93.75,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    12.8,
                                    12.8
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 6,
                                        "s": [
                                            0,
                                            0
                                        ],
                                        "to": [
                                            0,
                                            -2.667
                                        ],
                                        "ti": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 12,
                                        "s": [
                                            0,
                                            -16
                                        ],
                                        "to": [
                                            0,
                                            0
                                        ],
                                        "ti": [
                                            0,
                                            -2.667
                                        ]
                                    },
                                    {
                                        "t": 18.0,
                                        "s": [
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1568627450980392,
                                    0.396078431372549,
                                    0.5333333333333333,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    -25.204,
                                    -18.699
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Ellipse 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 330.000013441176,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Dot 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        58.233999999999995,
                        50.69899999999999,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        93.75,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    12.8,
                                    12.8
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 3,
                                        "s": [
                                            1,
                                            0
                                        ],
                                        "to": [
                                            0,
                                            -2.667
                                        ],
                                        "ti": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 9,
                                        "s": [
                                            1,
                                            -16
                                        ],
                                        "to": [
                                            0,
                                            0
                                        ],
                                        "ti": [
                                            0,
                                            -2.667
                                        ]
                                    },
                                    {
                                        "t": 15.0,
                                        "s": [
                                            1,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1568627450980392,
                                    0.396078431372549,
                                    0.5333333333333333,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    -25.204,
                                    -18.699
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Ellipse 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 330.000013441176,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Dot 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        31.25,
                        50.69899999999999,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        93.75,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    12.8,
                                    12.8
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            4,
                                            0
                                        ],
                                        "to": [
                                            0,
                                            -2.667
                                        ],
                                        "ti": [
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 6,
                                        "s": [
                                            4,
                                            -16
                                        ],
                                        "to": [
                                            0,
                                            0
                                        ],
                                        "ti": [
                                            0,
                                            -2.667
                                        ]
                                    },
                                    {
                                        "t": 12.0,
                                        "s": [
                                            4,
                                            0
                                        ]
                                    }
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1568627450980392,
                                    0.396078431372549,
                                    0.5333333333333333,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    -25.204,
                                    -18.699
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Ellipse 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 330.000013441176,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}